import { atom } from 'recoil';

export const agentConfigAtom = atom({
  key: 'agentConfigAtom',
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});